// @flow

import * as React from 'react';
import { Route, Link } from 'react-router-dom';

import { Header } from './components/Header';
import { Home } from './routeComponents/Home';
import { About } from './routeComponents/About';
import ACA from './services/ClientAPI';

import AdsumSearch from '@adactive/arc-search';
import AdsumKeyboard from '@adactive/arc-keyboard';

import brace from 'brace';
import AceEditor from 'react-ace';

import 'brace/mode/jsx';
import 'brace/theme/monokai';

import './App.css';

type PropsType = {||};

class App extends React.Component<PropsType> {
    constructor(props) {
        super(props);

        this.fuseData = [];
        this.searchResultRef = React.createRef();

        this.onKeyClicked = this.onKeyClicked.bind(this);

        this.state = {
            openSearch: true,
            queryValue: '',
            searchResult: []
        }
    }

    UNSAFE_componentWillMount() {
        console.log("[ACA] :: ", ACA);
        this.fuseData = ACA.getAllPois();
    }

    onKeyClicked(value) {
        const result = this.searchResultRef.current.search(value);
        this.setState({
            queryValue: value,
            searchResult: result
        });
    }

    render() {
        const fuseOptions = {
            shouldSort: true,
            threshold: 0.3,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 1,
            keys: [
                {
                    name: 'name',
                    weight: 0.7
                },
                {
                    name: 'description',
                    weight: 0.3
                }
            ]
        };

        const searchResultStyle = {
            position: 'absolute',
            height: '280px',
            width: '800px',
            overflow: 'scroll',
            top: '480px',
            left: '100px',
            textAlign: 'left',
            border: '1px solid',
        };

        const searchWrapperCSS = {
            top: '-15px'
        };

        const inputCSS = {
            width: '700px',
            fontSize: '22px',
            fontWeight: 'bold',
            padding: '8px',
            border: '8px solid #5db8a9'
        };

        return (
            <div className="App">
                <Header logo={"http://adactivesas.github.io/adsum-react-components/logo.jpg"} />
                <div className="comp">
                    <AdsumSearch
                        isOpen={this.state.openSearch}
                        lang="en"
                        data={this.fuseData}
                        fuseOptions={fuseOptions}
                        queryValue={this.state.queryValue}
                        ref={this.searchResultRef}
                    />
                    <AdsumKeyboard
                        isOpen={this.state.openSearch}
                        lang={'en'}
                        currentValue={this.state.queryValue}
                        onKeyClicked={this.onKeyClicked}
                    />
                    <div className="searchResult" style={searchResultStyle}>
                        <pre>
                        {
                            this.state.searchResult.length > 0 ?
                                JSON.stringify(this.state.searchResult, undefined, 2)
                                :
                                'Empty'
                        }
                        </pre>
                    </div>
                </div>

                <div className="code">
                    <AceEditor
                        mode="jsx"
                        theme="monokai"
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        value={`import AdsumSearch from '@adactive/arc-search';
import AdsumKeyboard from '@adactive/arc-keyboard';
...
constructor(props) {
    this.searchResultRef = React.createRef();
}

// To retrieve results from AdsumSearch after clicking on Adsum Keyboard
onKeyClicked(value) {
    const result = this.searchResultRef.current.search(value);
    this.setState({
        queryValue: value,
        searchResult: result
    })
}

const fuseOptions = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: [
        {
            name: 'name',
            weight: 0.7
        },
        {
            name: 'description',
            weight: 0.3
        }
    ]
};

<AdsumSearch
    isOpen={this.state.openSearch}
    lang="en"
    data={this.fuseData}
    fuseOptions={fuseOptions}
    queryValue={this.state.queryValue}
    ref={this.searchResultRef}
/>
<AdsumKeyboard
    isOpen={this.state.openSearch}
    lang={'en'}
    currentValue={this.state.queryValue}
    onKeyClicked={this.onKeyClicked}
/>
`}
                        height='720px'
                        width='700px'
                    />
                </div>

                <div className="comp">
                    <AdsumSearch
                        isOpen={this.state.openSearch}
                        lang="en"
                        data={this.fuseData}
                        fuseOptions={fuseOptions}
                        queryValue={this.state.queryValue}
                        placeHolder="Search for Something"
                        searchWrapperCSS={searchWrapperCSS}
                        inputCSS={inputCSS}
                        ref={this.searchResultRef}
                    />
                    <AdsumKeyboard
                        isOpen={this.state.openSearch}
                        lang={'en'}
                        currentValue={this.state.queryValue}
                        onKeyClicked={this.onKeyClicked}
                    />
                    <div className="searchResult" style={searchResultStyle}>
                        <pre>
                        {
                            this.state.searchResult.length > 0 ?
                                JSON.stringify(this.state.searchResult, undefined, 2)
                                :
                                'Empty'
                        }
                        </pre>
                    </div>
                </div>

                <div className="code">
                    <AceEditor
                        mode="jsx"
                        theme="monokai"
                        name="UNIQUE_ID_OF_DIV"
                        editorProps={{$blockScrolling: true}}
                        fontSize={14}
                        value={`import AdsumSearch from '@adactive/arc-search';
import AdsumKeyboard from '@adactive/arc-keyboard';
...
constructor(props) {
    this.searchResultRef = React.createRef();
}

// To retrieve results from AdsumSearch after clicking on Adsum Keyboard
onKeyClicked(value) {
    const result = this.searchResultRef.current.search(value);
    this.setState({
        queryValue: value,
        searchResult: result
    })
}

const fuseOptions = {
    shouldSort: true,
    threshold: 0.3,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1,
    keys: [
        {
            name: 'name',
            weight: 0.7
        },
        {
            name: 'description',
            weight: 0.3
        }
    ]
};

const searchWrapperCSS = {
    top: '-15px';
};

const inputCSS = {
    width: '700px',
    fontSize: '22px',
    fontWeight: 'bold',
    padding: '8px',
    border: '8px solid #5db8a9'
};

<AdsumSearch
    isOpen={this.state.openSearch}
    lang="en"
    data={this.fuseData}
    fuseOptions={fuseOptions}
    queryValue={this.state.queryValue}
    placeHolder="Search for Something"
    searchWrapperCSS={searchWrapperCSS}
    inputCSS={inputCSS}
    ref={this.searchResultRef}
/>
<AdsumKeyboard
    isOpen={this.state.openSearch}
    lang={'en'}
    currentValue={this.state.queryValue}
    onKeyClicked={this.onKeyClicked}
/>
`}
                        height='720px'
                        width='700px'
                    />
                </div>

                {/*<nav>
                    <Link to="/">Home</Link>
                    <Link to="/about-us">About</Link>
                </nav>
                <main>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/about-us" component={About} />
                </main>*/}
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js